import i18n from '@/plugins/i18n';

// Rotas abertas pelo link enviado ao cliente: ficha e selfie (a rota real usa "acess", com um "c")
export const CUSTOMER_FORM_EXTERNAL_ACCESS_PATH = '/customers/external-acess/';

/* Funções, não strings: o texto é lido no idioma da tela na hora de mostrar. */
export const getExternalAccessSessionExpiredMessage = () =>
  i18n.t('formCustomer.externalAccessUi.sessionExpired');

export const getExistingPartnerLinkedNotice = () =>
  i18n.t('formCustomer.externalAccessUi.existingPartnerLinked');
